import { BlankState } from '@domain-group/suit-theme'

import blankImageUrl from './assets/filterBlankState.svg'

const ListBlankState = (props: { boxProps?: object }) => {
  const { boxProps } = props

  return (
    <BlankState boxProps={{ marginBottom: ['large', 'large', 0], ...boxProps }} imageUrl={blankImageUrl}>
      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Title>No Results Available</BlankState.Title>
      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Paragraph>No Results Available. Please try adjusting your filters.</BlankState.Paragraph>
    </BlankState>
  )
}

export default ListBlankState
